import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from 'react-tooltip';
import {auth} from '../config/firebase';
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";



const Navbar = ({user}) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(window.scrollY);

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        localStorage.removeItem("user");
        localStorage.removeItem("selectedMovies");
      })
      .catch((error) => {
        console.error("Sign out error:", error);
      });
  };

  const controlNavbar = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY !== lastScrollY) {
      if (currentScrollY < lastScrollY) {
        // Scrolling down → hide navbar
        setShow(false);
      } else {
        // Scrolling up → show navbar
        setShow(true);
      }
      setLastScrollY(currentScrollY);
    }
  };

  useEffect(() => {
    let timeoutId;

    const handleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(controlNavbar, 100); // debounce
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeoutId);
    };
  }, [lastScrollY]);
 
  return (
    <div
      className={`active ${
        show && "hidden"
      } fixed top-0 z-50 w-full  bg-slate-900 h-max backdrop-filter backdrop-blur-sm bg-opacity-30  shadow-lg `}
    >
      <div className="flex w-screen items-center  ">
        <div className=" w-full navbarr  mt-0 ml-0">
        
          <h1 className="w-max mob:text-[20px] mob:mt-[4px] md:mt-[6px]">  <Link to="/">📽️Movie Hinge </Link></h1>
         
        </div>
        <div className=" flex navbar md:mt-[7px] md:mr-11 mt-1 mb-2 mob:text-[15px] mob:mr-5 mob:ml-[1.2rem]  md:ml-0 w-screen items-center justify-center md:justify-end  ">
          {/* {
            user&&user?  
            <div className="hover:cursor" onClick={handleLogout}>Log OUT</div>

            :<div className="mr-5   hover:text-yellow-400 hover:animate-[wiggle_1.5s_ease-in_infinite_1000ms]">
            <Link to="/login">
            <svg data-tooltip-id="my-tooltip-profile" data-tooltip-content="PROFILE" className="md:w-[25px] mob:w-[17px] md:h-[25px] fill-[#ededed] hover:scale-150 hover:fill-yellow-400 delay-75" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">

<path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"></path>

</svg>
        
           </Link>
          </div>
          } */}
  <div className="relative mx-4 group">
          <svg  data-tooltip-content="PROFILE" className="md:w-[25px] mob:w-[17px] md:h-[25px] fill-[#ededed] hover:scale-150 hover:fill-yellow-400 delay-75" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">

<path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"></path>

</svg>
     
         <div className=" z-50 absolute top-8  right-[-60px] hidden hover:flex  text-slate-200 flex-col bg-slate-900 rounded-md bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-80 group-hover:block ">
          
            <div className="hover:bg-amber-400 rounded-md hover:bg-clip-padding hover:backdrop-filter  hover:bg-opacity-80 relative hover:cursor-pointer newfont px-8 hover:scale-[1.03] my-4" onClick={()=>{navigate("/profile")}}>PROFILE</div>
            <div className="hover:bg-amber-400 rounded-md hover:bg-clip-padding hover:backdrop-filter  hover:bg-opacity-80 relative hover:cursor-pointer newfont px-8 hover:scale-[1.03] my-4" onClick={()=>{navigate("/favourite")}}>FAVOURITES</div>
            <div className="hover:bg-amber-400 rounded-md hover:bg-clip-padding hover:backdrop-filter  hover:bg-opacity-80 relative hover:cursor-pointer newfont px-8 hover:scale-[1.03] my-4" onClick={()=>{navigate("/list")}}>LISTS</div>
            {user && <div className="hover:bg-amber-400 rounded-md hover:bg-clip-padding hover:backdrop-filter  hover:bg-opacity-80 relative hover:cursor-pointer newfont px-8 hover:scale-[1.03] my-4" onClick={handleLogout}>LOG OUT</div>
}
          </div>
          </div>
        
        
          <div className="mr-5  hover:text-yellow-400  w-max hover:animate-[wiggle_1.5s_ease-in_infinite_1000ms]">
            <Link to="/popular/movie">
             
<svg data-tooltip-id="my-tooltip-movie" data-tooltip-content="POPULAR MOVIE" className="  md:w-[25px] md:h-[25px] mob:w-[18px] fill-[#ededed]  hover:scale-150 delay-75  hover:fill-yellow-400" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">

<path d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM48 368v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H416zM48 240v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H416zM48 112v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H416zM160 128v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z"></path>

</svg>  
            </Link>

          </div>
          {/* //yet to change it to tv */}
          <div className="mr-5   hover:text-yellow-400 hover:animate-[wiggle_1.5s_ease-in_infinite_1000ms]">
            <Link to="/popular/tv">
              
              <svg data-tooltip-id="my-tooltip-tv" data-tooltip-content="POPULAR TV" className="md:w-[25px] mob:w-[19px] md:h-[25px] fill-[#ededed] hover:scale-150 hover:fill-yellow-400 delay-75" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">

<path d="M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"></path>

</svg>
           </Link>
          </div>
          <div className=" mr-5 mob:w-[20px]   hover:text-yellow-400 hover:animate-[wiggle_1.5s_ease-in_infinite_1000ms]  ">
            
            <Link to="/search">
            <svg data-tooltip-id="my-tooltip-search" data-tooltip-content="SEARCH" className="md:w-[24px] md:h-[24px] mob:h-[18px]  md:mt-0 fill-[#ededed] hover:fill-yellow-400 hover:scale-150 delay-75 mob:mr-1 md:mr-7" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">

<path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"></path>

</svg> 
            </Link>
          </div>
          {/* <h2>Movies</h2>
            <h2>Tv</h2>
            <h2>Search</h2> */}
        </div>
 
        {/* <div className='flex'>
    <div className=''>
        Search
    </div>
 
    <div>
        Popular
    </div>
</div> */}
      </div>
      <Tooltip id="my-tooltip-profile" className="bg-yellow-400" style={{ backgroundColor: "rgb(250 204 21)",fontSize:'10px', color: "black",fontStyle:'italic',fontWeight:'bold',padding:"0 6px 0 6px" }} />

      <Tooltip id="my-tooltip-search" className="bg-yellow-400" style={{ backgroundColor: "rgb(250 204 21)",fontSize:'10px', color: "black",fontStyle:'italic',fontWeight:'bold',padding:"0 6px 0 6px" }} />
      <Tooltip id="my-tooltip-tv" className="bg-yellow-400" style={{ backgroundColor: "rgb(250 204 21)",fontSize:'10px', color: "black",fontStyle:'italic',fontWeight:'bold',padding:"0 6px 0 6px" }} />
      <Tooltip id="my-tooltip-movie" className="bg-yellow-400" style={{ backgroundColor: "rgb(250 204 21)",fontSize:'10px', color: "black",fontStyle:'italic',fontWeight:'bold',padding:"0 6px 0 6px" }} />

    </div>
  );
};
 
export default Navbar;
 